import React from 'react';
import { StubLabel } from 'Components/Texts';
import './BoxInputField.css';

export const BoxInputField = ({
  name,
  onBlur,
  label,
  placeholder,
  error,
  touched,
  value = '',
  handleChange,
  ariaLabel,
}) => {
  const inputClassName = touched && error ? 'boxInputField inputError' : 'boxInputField';

  const labelId = label && !ariaLabel ? `box-input-${label.replace(/\s+/g, '')}` : null;

  return (
    <div className="boxInputFieldContainer">
      {label && <StubLabel text={label} id={labelId} />}
      <div>
        <input
          name={name}
          className={inputClassName}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          aria-label={ariaLabel}
          aria-labelledby={labelId}
        />
        {touched && error && <div className="formFieldError">{error}</div>}
      </div>
    </div>
  );
};
